module.exports = __webpack_public_path__ + "static/media/i1.9d628ee4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/i1.jpeg
// module id = 25
// module chunks = 0